import { apiRegister } from '../../common/api'
// import { NO_ERROR } from '../../const'

export const slideImageLoad = apiRegister('slideImageLoad', {
  protoId: 986,
  path: '/xsh/config/cycleimglist/'
  // checkQuery(Q) {
  //   return NO_ERROR
  // },
  // formatResult(R) {
  //   return R
  // }
}).send

export const hxlessonInfo = apiRegister('hxlessonInfo', {
  protoId: 528,
  path : '/award/hxlesson/info/',
  formatResult: function(R) {
      return R;
  }
}).send

// 根据 传入的 草根之来源 获取登陆用户的 草根值获取的详细信息
//sources	string	来源，多个用逗号隔开 1论坛商城，2后台设置，3斗k，4语音课，5大礼包，6游学，7有赞商城，8双11售卖，9新浪创新语音课，11主站操作，12和讯速成班U盘售卖，13礼品卡， 14和讯速成班，15和讯实战训练营
export const mySourceExpInfo = apiRegister('my-exp-info', {
  protoId: 1132,
  path: '/user/power/get/by/source/',
  checkResult() {    
    return 0
  }
}).send

/**
 *获取会员等级基本信息
 */

export const myLeveInfo = apiRegister('user.level.info',{
  protoId: 786,
  path: '/user/power/info/',
  checkResult(R) {
      return 0;
  },
  formatQuery: function(Q) {
    Q.nextLevel = 1;
  },
  formatResult: function(R) {
    return R;
  }
}).send